import {combineReducers, Reducer} from 'redux'
import {JobsState} from '@models/job'
import {JobsActionTypes} from '@actions/job';


// Type-safe initialState!
export const initialState: JobsState = {
    allIds: [],
    byId: {},
    loading: false,
    count: 0
};


const byId = (state = initialState.byId, action) => {
    switch (action.type) {
        case JobsActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return {
                ...data.reduce((obj, job) => {
                    obj[job.id] = {
                        ...job,
                        is_fetched: false,
                        ...(state[job.id] || {}), //The data which fetch by id is more than data in Table
                    };
                    return obj;
                }, {})
            };
        }

        case JobsActionTypes.CREATE_SUCCESS: {
            const job = action.payload;
            return {
                ...state,
                [job.id]: job
            };
        }

        case JobsActionTypes.UPDATE_SUCCESS: {
            const job = action.payload;
            return {
                ...state,
                [job.id]: {
                    ...state[job.id],
                    ...job
                }
            };
        }

        case JobsActionTypes.FETCH_ITEM_SUCCESS: {
            const job = action.payload;
            return {
                ...state,
                [job.id]: {
                    ...state[job.id],
                    ...job,
                    is_fetched: true
                },
            };
        }

        case JobsActionTypes.DELETE_SUCCESS:
            return Object.keys(state)
                .filter(id => id !== action.payload.id)
                .reduce((result, current) => {
                    result[current] = state[current];
                    return result;
                }, {});


        default:
            return state;
    }
};


const allIds = (state = initialState.allIds, action) => {
    switch (action.type) {
        case JobsActionTypes.FETCH_SUCCESS: {
            const {data} = action.payload;
            return data.map(item => item.id);
        }

        case JobsActionTypes.DELETE_SUCCESS:
            const deletedFormIndex = state.indexOf(action.payload.id);
            return [...state.slice(0, deletedFormIndex), ...state.slice(deletedFormIndex + 1)];

        case JobsActionTypes.CREATE_SUCCESS:
            return [action.payload.id, ...state];

        default:
            return state
    }
};


const count = (state = initialState.count, action) => {
    switch (action.type) {
        case JobsActionTypes.FETCH_SUCCESS: {
            const {meta} = action.payload;
            return meta.total_count;
        }

        case JobsActionTypes.DELETE_SUCCESS:
            return state - 1;

        case JobsActionTypes.CREATE_SUCCESS:
            return state + 1;


        default:
            return state
    }
};

const loading = (state = initialState.loading, action) => {
    switch (action.type) {
        case JobsActionTypes.FETCH_REQUEST: {
            return true;
        }

        case JobsActionTypes.FETCH_SUCCESS:
        case JobsActionTypes.FETCH_ERROR:
            return false;

        default:
            return state
    }
};


const reducer: Reducer<JobsState> = combineReducers({
    byId,
    allIds,
    count,
    loading
});

export {reducer as jobReducer}


//Selectors
export const getJobsList = jobs => jobs.allIds.map(id => jobs.byId[id]);

export const getJobById = (jobs, id) => jobs.byId[id];